import { icons } from './icons';

export function showToast(message: string, type: 'info' | 'success' | 'warning' | 'error' = 'info', durationMs = 4000): void {
  const container = document.getElementById('toast-root');
  if (!container) return;

  const toast = document.createElement('div');
  toast.className = `pointer-events-auto flex items-center gap-3 px-4 py-3 rounded-xl card-workbench shadow-lg border text-xs sm:text-sm font-medium transition-all transform translate-y-2 opacity-0 max-w-md ${
    type === 'success'
      ? 'border-[var(--color-success-border)] text-emerald-950 bg-[var(--color-success-subtle)]'
      : type === 'error'
      ? 'border-[var(--color-danger)] text-red-950 bg-[var(--color-danger-subtle)]'
      : type === 'warning'
      ? 'border-[var(--color-warning-border)] text-amber-950 bg-[var(--color-warning-subtle)]'
      : 'border-[var(--color-accent-subtle-border)] text-[var(--color-ink)] bg-[var(--color-paper-card)]'
  }`;

  const iconSvg =
    type === 'success'
      ? `<span class="text-emerald-600">${icons.checkCircle}</span>`
      : type === 'error'
      ? `<span class="text-red-600">${icons.alertCircle}</span>`
      : type === 'warning'
      ? `<span class="text-amber-600">${icons.alertCircle}</span>`
      : `<span class="text-purple-600">${icons.zap}</span>`;

  toast.innerHTML = `
    <span class="shrink-0 flex items-center">${iconSvg}</span>
    <span class="grow leading-tight">${message}</span>
  `;

  container.appendChild(toast);

  // Animate in
  requestAnimationFrame(() => {
    toast.classList.remove('translate-y-2', 'opacity-0');
    toast.classList.add('translate-y-0', 'opacity-100');
  });

  // Auto remove
  setTimeout(() => {
    toast.classList.add('opacity-0', 'translate-x-4');
    setTimeout(() => {
      if (toast.parentNode === container) {
        container.removeChild(toast);
      }
    }, 300);
  }, durationMs);
}
